var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('monaco-editor',{attrs:{"read-only":_vm.disabled,"language":_vm.language,"options":_vm.options,"height":_vm.height},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})}
var staticRenderFns = []

export { render, staticRenderFns }